var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ProfilePicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#90caf9",
    d: "M20,0A20,20,0,1,0,40,20,20,20,0,0,0,20,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b5f6",
    d: "M27.933,16.933A7.933,7.933,0,1,1,20,9a7.932,7.932,0,0,1,7.933,7.933"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b5f6",
    d: "M20,28.267A17.036,17.036,0,0,0,6.521,34.745a19.914,19.914,0,0,0,26.958,0A17.036,17.036,0,0,0,20,28.267Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ProfilePicture);
export default __webpack_public_path__ + "static/media/icons8-profile-picture.80b62f4dae28c5f69b324b4a11b15991.svg";
export { ForwardRef as ReactComponent };